<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <div class="bg-sidebar"></div>
    <nav class="sidebar-nav">
      <div v-for="i in 200" class="snow"></div>
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
            <SidebarNavTitle v-if="(item.name === 'system_management') ? !sysFlag : !userFlag" :name="$t('side_bar.'+item.name)" :classes="item.class" :wrapper="item.wrapper"/>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel :name="$t('side_bar.'+item.name)" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children && !item.disable">
              <!-- First level dropdown -->
              <SidebarNavDropdown :name="$t('side_bar.'+item.name)" :url="item.url" :icon="item.icon">
                <template v-for="(childL1, index) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown v-if="!childL1.disable" :name="$t('side_bar.'+childL1.name)" :url="childL1.url" :icon="childL1.icon">
                      <li class="nav-item" v-for="(childL2, index) in childL1.children">
                        <SidebarNavLink :name="$t('side_bar.'+childL2.name)" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem v-if="!childL1.disable" :classes="item.class">
                      <SidebarNavLink :name="$t('side_bar.'+childL1.name)" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem v-if="(item.name === 'menu_half_half') && single && single.config.menu_half_half && !item.disable" :classes="item.class">
                <SidebarNavLink  :name="$t('side_bar.'+item.name)" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              </SidebarNavItem>
              <SidebarNavItem v-else-if="(item.name !== 'menu_half_half') && !item.disable" :classes="item.class">
                <SidebarNavLink v-show="!(item.name === 'combo' && checkPermission($auth.user(),'rgm-role-editable'))" :name="$t('side_bar.'+item.name)" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              </SidebarNavItem>

            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
export default {
  name: 'sidebar',
  props: ["navItems", "sysFlag", "userFlag"],
  data: function () {
    return {
      single: this.$store.getters.config.gms.menu_half_half
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
  ul .nav-dropdown-items {
    padding-left: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue